import React, { Fragment } from 'react';

import Footer from 'components/footer';

export default ({ children }) => (
  <Fragment>
    {children}
    <Footer />
  </Fragment>
);
